<template>
  <div class="order">
    <search
      :recordsSearchObj="recordsSearchObj"
      :carTypeList="carTypeList"
      @handleSearch="handleSearch"
    />
    <div class="table-container">
      <div class="table-btn">
        <!-- :loading="exportLoading" -->
        <el-button
          type="text"
          icon="el-icon-download"
          @click="handleExport"
          >导出</el-button
        >
      </div>
        <!-- v-loading="loading" -->
      <el-table
        :data="tableData"
        border
        stripe
        highlight-current-row
      >
        <el-table-column type="selection" width="40" align="center">
        </el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="claimStatementId"
          label="索赔单号"
          :min-width="$getColumnWidth('claimStatementId', tableData)"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="customerAccount"
          label="客户账号"
          :min-width="$getColumnWidth('customerAccount', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="customerClaimNumber"
          label="客户索赔单号"
          :min-width="$getColumnWidth('customerClaimNumber', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户名称"
          :min-width="$getColumnWidth('customerName', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="country"
          label="国家"
          min-width="120"
          show-overflow-tooltip
          column-key="country"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.country }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="faultPartNumber"
          label="故障件代码"
          :min-width="$getColumnWidth('faultPartNumber', tableData)"
        >
        </el-table-column>
        <el-table-column
          prop="faultPartName"
          label="故障件名称"
          :min-width="$getColumnWidth('faultPartName', tableData)"
        >
        </el-table-column>
        <el-table-column
          prop="happenDate"
          label="发生日期"
          :min-width="$getColumnWidth('happenDate', tableData)"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="申请时间"
          :min-width="$getColumnWidth('createTime', tableData)"
          align="center"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.createTime?scope.row.createTime.replace("T", " "):'-' }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="preapprovalName"
          label="预审人"
          :min-width="$getColumnWidth('preapprovalName', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="auditResultDisplay"
          label="状态"
          :min-width="$getColumnWidth('status', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="auditTime"
          label="审核时间"
          :min-width="$getColumnWidth('auditTime', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="preapprovalPassTime"
          label="预审通过日期"
          :min-width="$getColumnWidth('preapprovalPassTime', tableData)"
          align="center"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="130px"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="toDetail(scope.row)"
              >查看</el-button
            >
            <el-button
              v-if="scope.row.status == 1 || scope.row.status == 4"
              size="mini"
              type="text"
              @click="handleAudit(scope.row, scope.$index)"
              >审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fenye" v-show="total > 0">
        <pagination
          :total="total"
          :page.sync="page"
          :limit.sync="pageSize"
          @pagination="handlePaginationChange"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {kdPreClimantList, kdpretrialClimantExport, pretrialClimantExport} from "@/api/seek";
import search from "./components/readySearch";
import { getNations } from "@/util/getNation";
import { getSession, setStorage } from "@/util/localStor";
import { getDownloadFiles } from "@/util/downFile";
import { getDictItem } from "@/util/dict";

export default {
  components: {
    search
  },
  data() {
    const { data, pageNum, pageSize } = this.$route?.query?.searchObj
      ? JSON.parse(this.$route?.query?.searchObj)
      : {};
    return {
      // loading: false,
      tableData: [],
      page: Number(pageNum) || 1,
      pageSize: Number(pageSize) || 10,
      total: 0,
      searchInfo: {
        status: "1"
      },
      // exportLoading: false,
      recordsSearchObj: data,

      searchData: {},
      carTypeList: []
    };
  },
  async mounted() {
    this.searchInfo = this.recordsSearchObj
      ? JSON.parse(JSON.stringify(this.recordsSearchObj))
      : this.searchInfo;
    this.getList();
    // 获取车型
    const carTypeList = await getDictItem("carType");
    carTypeList.map(item => {
      this.carTypeList.push({ text: item.value, value: item.code });
    });
  },
  methods: {
    // 获取国家
    getCountry(data) {
      let country = getNations(data);
      return country;
    },
    // 搜索
    handleSearch(data) {
      this.searchData = JSON.parse(JSON.stringify(data));
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.lbjzy = data.lbjzy;
      this.searchInfo.claimStatementId = data.claimStatementId;
      this.searchInfo.status = data.status;
      this.searchInfo.claimStatementNum = data.claimStatementNum;
      this.searchInfo.customerAccount = data.customerAccount;
      this.searchInfo.faultPartNumber = data.faultPartNumber;
      this.searchInfo.faultPartName = data.faultPartName;
      this.searchInfo.claimType = data.claimType
      data.country=='0'?this.searchInfo.country = '':this.searchInfo.country = data.country
      if (data.preapprovalPassTime !== "" && data.preapprovalPassTime !== null) {
        this.searchInfo.preapprovalPassTimeStart = data.preapprovalPassTime[0] + " 00:00:00";
        this.searchInfo.preapprovalPassTimeEnd = data.preapprovalPassTime[1] + " 23:59:59";
      } else {
        this.searchInfo.preapprovalPassTimeStart = "";
        this.searchInfo.preapprovalPassTimeEnd  = "";
      }
      if (data.createTime !== "" && data.createTime !== null) {
        this.searchInfo.createTimeStart =
          data.createTime[0] + " 00:00:00";
        this.searchInfo.createTimeEnd = data.createTime[1] + " 23:59:59";
      } else {
        this.searchInfo.createTimeStart = "";
        this.searchInfo.createTimeEnd = "";
      }

      if (data.happenTime !== "" && data.happenTime !== null) {
        this.searchInfo.happenTimeStart = data.happenTime[0] + " 00:00:00";
        this.searchInfo.happenTimeEnd = data.happenTime[1] + " 23:59:59";
      } else {
        this.searchInfo.happenTimeStart = "";
        this.searchInfo.happenTimeEnd = "";
      }
      this.searchInfo.customerClaimNumber = data.customerClaimNumber;
      this.getList();
    },
    // 记录当前列表搜索条件
    recordSearchObj() {
      this.$router.replace(
        "/kd-claimantList?searchObj=" +
          JSON.stringify({
            data: {
              ...this.searchInfo,
              date: this.searchInfo.preapprovalPassTimeStart
                ? [
                    this.searchInfo.preapprovalPassTimeStart.split(" ")[0],
                    this.searchInfo.preapprovalPassTimeEnd.split(" ")[0]
                  ]
                : "",
              applyDate: this.searchInfo.createTimeStart
                ? [
                    this.searchInfo.createTimeStart.split(" ")[0],
                    this.searchInfo.createTimeEnd.split(" ")[0]
                  ]
                : "",
              happenTime: this.searchInfo.happenTimeStart
                ? [
                    this.searchInfo.happenTimeStart.split(" ")[0],
                    this.searchInfo.happenTimeEnd.split(" ")[0]
                  ]
                : ""
            },
            pageNum: this.page,
            pageSize: this.pageSize
          })
      );
    },
    // 查看
    toDetail(data) {
      setStorage("claimantData", data);
      localStorage.setItem("his", 1);
      this.recordSearchObj();
      this.$router.push({
        path: "/kd-claimant/preDetail",
        query: { claimantId: data.claimStatementId }
      });
    },
    // 审核
    handleAudit(data, index) {
      setStorage("claimantData", data);
      localStorage.setItem("his", 1);
      this.recordSearchObj();
      this.$router.push({
        path: "/kd-claimant/edit",
        query: {
          claimantId: data.claimStatementId,
          searchObj: JSON.stringify({
            data: {
              ...this.searchInfo
            },
            page: {
              pageNum:
                (Number(this.page) - 1) * Number(this.pageSize) + index + 1,
              pageSize: 1
            }
          }),
          enableNext: this.searchInfo.status === "1" ? "1" : "0"
        }
      });
    },
    // 导出
    async handleExport() {
      // this.exportLoading = true;
      let query = {
        ...this.searchInfo
      };
      const res = await kdpretrialClimantExport(query);
      getDownloadFiles(res);
      if (res.fileName) {
        this.$DonMessage.success("导出成功！")
      }
      // this.exportLoading = false;
    },
    // 分页
    handlePaginationChange(val) {
      this.page = val.page;
      this.pageSize = val.limit;
      this.getList();
    },
    // 获取列表
    async getList() {
      // this.loading = true;
      let query = {
        data: {
          ...this.searchInfo
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize
        }
      };
      const res = await kdPreClimantList(query);
      if (res.status == 0) {
        this.tableData = res.data.records;
        this.total = res.data.count;
        // this.loading = false;
      }
      // this.loading = false;
    },
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<!-- <style lang="scss" scoped>
.table-container {
  padding: 0 7px 0 23px;
}
</style> -->
